import {
  FormFieldAutocompleteWrapper,
  FormFieldUploadWrapper,
  FormFieldTextWrapper,
  FormFieldRadioWrapper,
  FormFieldAutocompleteNameWrapper,
  FormFieldCheckboxWrapper,
  FormFieldCheckboxGroupWrapper,
  FormFieldAutocompleteLegalEntityWrapper,
  FormFieldLimitedAutocompleteLegalEntityWrapper
} from "../FormFieldWrappers";

export default {
  text: FormFieldTextWrapper,
  radio: FormFieldRadioWrapper,
  checkbox: FormFieldCheckboxWrapper,
  checkboxGroup: FormFieldCheckboxGroupWrapper,
  nameAutocomplete: FormFieldAutocompleteNameWrapper,
  legalEntityAutocomplete: FormFieldAutocompleteLegalEntityWrapper,
  legalLimitedEntityAutocomplete: FormFieldLimitedAutocompleteLegalEntityWrapper,
  file: FormFieldUploadWrapper,
  autocomplete: FormFieldAutocompleteWrapper,
};
